"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _button = _interopRequireDefault(require("@ux/button"));
const SpinAuctionRedirectButton = ({
  makeOfferTextId,
  fqdn,
  auctionUrl
}) => {
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-cy": `${fqdn}_spin-auction-redirect-button`,
    "data-testid": `${fqdn}_spin-auction-redirect-button`,
    href: auctionUrl,
    text: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: makeOfferTextId
    }),
    design: "primary"
  });
};
SpinAuctionRedirectButton.propTypes = {
  auctionUrl: _propTypes.default.string.isRequired,
  makeOfferTextId: _propTypes.default.string.isRequired,
  fqdn: _propTypes.default.string.isRequired
};
var _default = exports.default = SpinAuctionRedirectButton;